import { Box } from "@mui/material";

export default function FormWrapper({ children, onSubmit, ...rest }) {
	const handleKeyDown = (e) => {
		if (e.key === "Enter" && e.target.nodeName !== "TEXTAREA") {
			e.preventDefault(); // block Enter submit unless it's a textarea
		}
	};

	return (
		<Box
			component="form"
			onSubmit={onSubmit}
			onKeyDown={handleKeyDown}
			{...rest}
		>
			{children}
		</Box>
	);
}
